import { render, staticRenderFns } from "./AccountingTVA.vue?vue&type=template&id=bdef30b6"
import script from "./AccountingTVA.vue?vue&type=script&lang=js"
export * from "./AccountingTVA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports